<!-- [style.backgroundImage]="'url('+ bulletin?.image.url +')'" -->

<div class="search-section relative overflow-hidden">
  <uni-image *ngIf="bulletin?.image?.url" [src]="bulletin.image.url" alt="search cover image" 
    [width]="imageWidth" [height]="360" classes="height-100 width-100 fit-cover search-section-img" class="absolute"></uni-image>
  <div class="absolute width-100 height-100" fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="24px">
    <form class="navbar-item-search" [formGroup]="searchfield" (ngSubmit)="onSubmit()">
      <div class="search-bar">
        <i class="sparro-grey-500 icon-search"></i>
        <input type="font-sm" formControlName="search" [placeholder]="placeholder ? placeholder : 'Search on UNI'" name="search"
          oninput="this.value = this.value.toLowerCase()" class="search-bar-input">
      </div>
    </form>
  
    <ng-container *ngIf="showOptions">
      <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="24px">
        <div fxLayout="row" fxLayoutAlign="center center" class="filter-button-section cursor-pointer" (click)="toggleFilter()">
          <i class="icon-filter-fill margin-right-1"></i>
          <p class="margin-0">Filter</p>
        </div>
        <div fxLayout="row" fxLayoutAlign="center center" class="filter-button-section cursor-pointer" (click)="toggleSort()">
          <i class="icon-sort-bold margin-right-1"></i>
          <p class="margin-0">{{ orderTitle ? orderTitle : 'Sort' }}</p>
        </div>
      </div>
    </ng-container>
  </div>
  <span class="credit-section absolute font-xxs" [innerHtml]="bulletin?.info | safeContent"></span>
</div>